import { toast } from '@london-life/ui/feedback/game-toaster';
import type { ChatMessage } from '@london-life/contracts';
import { PersonPicture } from '../people/person-card';

// a short two-note chime, made in the browser (no sound file to load)
export function playChime() {
  try {
    const Context =
      window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Context) return;
    const audio = new Context();
    const gain = audio.createGain();
    gain.connect(audio.destination);
    gain.gain.setValueAtTime(0.0001, audio.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.18, audio.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, audio.currentTime + 0.45);
    for (const [frequency, at] of [
      [880, 0],
      [1320, 0.12],
    ] as const) {
      const tone = audio.createOscillator();
      tone.type = 'sine';
      tone.frequency.value = frequency;
      tone.connect(gain);
      tone.start(audio.currentTime + at);
      tone.stop(audio.currentTime + at + 0.3);
    }
    window.setTimeout(() => void audio.close(), 800);
  } catch {
    // no sound is fine
  }
}

// what a message says in a pop-up
export const popupText = (message: ChatMessage) => {
  if (message.deletedAt) return 'Message deleted';
  if (message.kind === 'sticker') return 'Sent a sticker';
  if (message.kind === 'voice') return '🎤 Voice note';
  return message.text ?? '';
};

// A new message while you are elsewhere in the game: a snackbar with who and what; tap it to open the chat.
// One per chat, so a burst of messages updates the same snackbar.
export function showMessageToast(message: ChatMessage, groupName: string | null, onOpen: () => void) {
  toast.custom(
    (id) => (
      <div className="message-popup">
        <button
          type="button"
          className="message-popup-open"
          onClick={() => {
            toast.dismiss(id);
            onOpen();
          }}
        >
          <PersonPicture person={message.sender} />
          <span>
            <b>
              {message.sender.firstName}
              {groupName && <small> in {groupName}</small>}
            </b>
            <span>{popupText(message)}</span>
          </span>
        </button>
        <button type="button" className="message-popup-close" aria-label="Dismiss" onClick={() => toast.dismiss(id)}>
          ×
        </button>
      </div>
    ),
    { id: `chat:${message.conversationId}`, duration: 5000 },
  );
}
